<template>
  <div>
    <div class="language">
      <span
        class="left"
        :class="{ opacity3: $i18n.locale === 'en' }"
        @click="langChange('zh')"
        >中文</span
      >
      <span class="border">/</span>
      <span
        class="right"
        :class="{ opacity3: $i18n.locale === 'zh' }"
        @click="langChange('en')"
        >EN</span
      >
    </div>
    <van-popup v-model="show" position="bottom" :overlay="false" round>
      <div class="form-box">
        <div class="form-header" v-if="$route.params.type === 'GT'">
          <van-tabs
            v-model="activeTab"
            :swipe-threshold="0"
            @click="loginTypeChange"
          >
            <van-tab :title="$t('invitation_login')" name="id"></van-tab>
            <van-tab :title="$t('mobile_verification')" name="phone"></van-tab>
            <van-tab :title="$t('email_verification')" name="email"></van-tab>
          </van-tabs>
        </div>
        <div class="form-body">
          <van-form ref="form1" @submit="Submit" v-show="activeTab === 'id'">
            <div class="input">
              <van-field
                v-model="form.account"
                @blur="handleAccountBlur"
                :placeholder="
                  $route.params.type !== 'GT'
                    ? $t3('邮箱', 'E-mail')
                    : types[typeIdx]
                "
                :rules="[
                  {
                    required: true,
                    message: $t(
                      $route.params.type !== 'GT'
                        ? 'input.emailTip'
                        : 'input.invitationTip'
                    ),
                  },
                ]"
              >
              </van-field>
            </div>
            <div class="input">
              <van-field
                type="password"
                v-model="form.password"
                :placeholder="$t('password')"
                :rules="[{ required: true, message: $t('input.pasTip') }]"
              />
            </div>
            <div class="input" v-show="$route.params.type === 'GT'">
              <van-field
                :disabled="disableLocation"
                :readonly="true"
                v-model="form.location"
                right-icon="arrow-down"
                @click="disableLocation ? '' : (showLocationPicker = true)"
                :rules="[
                  {
                    required: $route.params.type === 'GT',
                    message: $t('input.locationTip'),
                  },
                ]"
              >
                <template #input>
                  <input
                    type="text"
                    readonly="readonly"
                    :placeholder="$t3('归属地', 'Based in')"
                    class="van-field__control"
                    :value="dict.location[form.location]"
                  />
                </template>
              </van-field>
            </div>
            <div class="input row">
              <van-field
                v-model="form.kaptcha"
                name="验证码"
                :placeholder="$t('code')"
                :rules="[{ required: true, message: $t('input.codeTip') }]"
              />
              <div class="code-img">
                <img :src="kaptchaImg" @click="getKaptcha" />
              </div>
              <div
                class="code-text"
                v-text="$t('codeTxt')"
                @click="getKaptcha"
              ></div>
            </div>
            <van-button
              class="submit-button"
              round
              block
              type="info"
              native-type="submit"
              >{{ $t("pageTitle.login") }}</van-button
            >
            <!-- TODO 隐藏媒体记者注册v-if="(canRegister && $route.params.type !== 'MT')" -->
            <!-- TODO 隐藏工作人员注册v-if="(canRegister && $route.params.type !== 'WK')" -->
            <van-button
              round
              plain
              type="info"
              class="register-btn"
              @click.prevent="goRegister"
              v-if="
                canRegister &&
                $route.params.type !== 'GT'
              "
              >{{ $t("register2") }}</van-button
            >
          </van-form>
          <van-form
            ref="form"
            @submit="SubmitNoCapture"
            v-show="activeTab !== 'id'"
          >
            <div class="input">
              <van-field
                name="account"
                v-model="form.account"
                @blur="handleAccountBlur"
                :placeholder="
                  activeTab === 'email'
                    ? $t3('邮箱', 'E-mail')
                    : $t3('手机号', 'Phone')
                "
                :rules="[
                  {
                    required: true,
                    message: $t(
                      activeTab === 'email'
                        ? 'input.emailTip'
                        : 'input.phoneTip'
                    ),
                  },
                  {
                    validator: validateAccount,
                  },
                ]"
              >
              </van-field>
            </div>
            <div class="input" v-show="$route.params.type === 'GT'">
              <van-field
                :disabled="disableLocation"
                :readonly="true"
                v-model="form.location"
                right-icon="arrow-down"
                @click="disableLocation ? '' : (showLocationPicker = true)"
                :rules="[
                  {
                    required: $route.params.type === 'GT',
                    message: $t('input.locationTip'),
                  },
                ]"
              >
                <template #input>
                  <input
                    type="text"
                    readonly="readonly"
                    :placeholder="$t3('归属地', 'Based in')"
                    class="van-field__control"
                    :value="dict.location[form.location]"
                  />
                </template>
              </van-field>
            </div>
            <div class="input row">
              <van-field
                v-model="form.password"
                name="验证码"
                :placeholder="$t('code')"
                :rules="[{ required: true, message: $t('input.codeTip') }]"
              >
                <template #button>
                  <div
                    class="code-button"
                    @click="codeFreeze ? '' : sendCode()"
                  >
                    {{ !codeFreeze ? $t("obtain_code") : codeTime + "s" }}
                  </div>
                </template>
              </van-field>
            </div>
            <van-button
              class="submit-button"
              round
              block
              type="info"
              native-type="submit"
              >{{ $t("pageTitle.login") }}</van-button
            >
            <!-- TODO 隐藏媒体记者注册v-if="(canRegister && $route.params.type !== 'MT')" -->
            <!-- TODO 隐藏工作人员注册v-if="(canRegister && $route.params.type !== 'WK')" -->
            <van-button
              round
              plain
              type="info"
              class="register-btn"
              @click.prevent="goRegister"
              v-if="
                canRegister &&
                $route.params.type !== 'WK' &&
                $route.params.type !== 'GT'
              "
              >{{ $t("register2") }}</van-button
            >
          </van-form>
          <div
            class="forgot-password"
            :class="$t3('', 'en')"
            v-show="activeTab === 'id'"
          >
            <span @click="$router.push('setPassword')">{{
              $t("forgotPas")
            }}</span>
          </div>
        </div>
        <!-- 选择框 -->
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="types"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-popup v-model="showLocationPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="locations"
            @confirm="onConfirmLocation"
            @cancel="showLocationPicker = false"
          >
            <template #option="item">
              {{ dict.location[item] }}
            </template>
          </van-picker>
        </van-popup>
      </div>
    </van-popup>
  </div>
</template>

<script>
import i18n from "@/utils/lang"
import { getConferenceInfo } from "@/api/conference";
import { getGraphKaptcha } from "@/api/kaptcha";
import {
  guestLogin,
  guestLoginNoCapture,
  mediaLogin,
  workerLogin,
  guangzhouLogin
} from "@/api/login";
import {
  getLocationInfo,
  getLocationInfoPhone,
  getLocationInfoEmail,
} from "@/api/guest";
import {
  sendSmsCode,
  sendEmailCode,
  checkSmsExist,
  checkEmailExist,
} from "@/api/sendCode";
import { mapGetters } from "vuex";

const tmpForm = {
  loginType: "id",
  conferenceId: undefined,
  cToken: undefined,
  kaptcha: undefined,
  account: undefined,
  password: undefined,
  location: undefined,
};

export default {
  name: "login",
  data() {
    return {
      mail: "",
      password: "",
      code: "",
      loginBtn: "message.homeBtn",
      show: true,
      type: this.$route.params.type,
      kaptchaImg: "",
      form: Object.assign({}, tmpForm),
      canRegister: false,
      labels: [],
      types: [],
      locations: [],
      dict: {
        location: {},
      },
      loginTypeDict: ["email", "phone", "id"],
      typeIdx: 2,
      showPicker: false,
      showLocationPicker: false,
      disableLocation: false,
      activeTab: "id",
      codeTime: 0,
      codeInitTime: 60,
      cToken: "",
    };
  },
  created() {
    this.getKaptcha();
    if (this.$route.params.type === "GT") {
      this.canRegister = false;
    } else {
      this.getConferenceInfo();
    }
    this.initLanguage();
    setInterval(() => {
      if (this.codeTime > 0) {
        this.codeTime--;
      }
    }, 1000);
    const lang = this.$route.query.lang
    if (Object.keys(i18n.messages).indexOf(lang) > -1) {
      this.langChange(lang)
    }
  },
  computed: {
    ...mapGetters(["showCount", "status"]),
    codeFreeze() {
      return this.codeTime > 0;
    },
  },
  methods: {
    initLanguage() {
      this.labels = [
        this.$t3("邮箱", "E-mail"),
        this.$t3("手机", "Phone"),
        this.$t3("邀请码", "Code"),
      ];
      this.types = [
        this.$t3("邮箱", "E-mail"),
        this.$t3("手机", "Phone"),
        this.$t3("邀请码", "Invitation Code"),
      ];
      this.locations = [
        this.$t3("广州本地", "Guangzhou"),
        this.$t3("外地", "Other Place"),
      ];
      this.dict = {
        location: {
          广州本地: this.$t3("广州本地", "Guangzhou"),
          外地: this.$t3("外地", "Other Place"),
          Local: this.$t3("广州本地", "Guangzhou"),
          Guangzhou: this.$t3("广州本地", "Guangzhou"),
          "Other Place": this.$t3("外地", "Other Place"),
        },
      };
    },
    getKaptcha() {
      getGraphKaptcha().then((res) => {
        if (res.data) {
          this.form.cToken = res.data.cToken;
          this.cToken = res.data.cToken;
          this.kaptchaImg = res.data.img
            ? "data:image/jpeg;base64," + res.data.img
            : "data:image/jpeg;base64,";
        }
      });
    },
    getConferenceInfo() {
      getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(
        (res) => {
          if (
            this.checkTimeBetween(
              res.data.registerStartTime,
              res.data.registerEndTime
            ) &&
            this.$route.params.type === "MT"
          ) {
            this.canRegister = true;
          } else if (
            this.checkTimeBetween(
              res.data.workerRegisterStartTime,
              res.data.workerRegisterEndTime
            ) &&
            this.$route.params.type === "WK"
          ) {
            this.canRegister = true;
          } else if (
            this.checkTimeBetween(
              res.data.guangzhouRegisterStartTime,
              res.data.guangzhouRegisterEndTime
            ) &&
            this.$route.params.type === "GZ"
          ) {
            this.canRegister = true;
          } else {
            this.canRegister = false;
          }
        }
      );
    },
    handleAccountBlur() {
      if (this.$route.params.type === "GT" && this.form.account) {
        if (this.activeTab === "id") {
          getLocationInfo({
            conferenceId: this.$route.params.conferenceId,
            guestId: this.form.account,
          }).then((res) => {
            if (res && res.data) {
              this.form.location = res.data.location;
              this.disableLocation = res.data.confirmBaseInfo === 1 && res.data.location;
            } else {
              this.disableLocation = false;
            }
          });
        } else if (this.activeTab === "phone") {
          getLocationInfoPhone({
            conferenceId: this.$route.params.conferenceId,
            phone: this.form.account,
          }).then((res) => {
            if (res && res.data) {
              this.form.location = res.data.location;
              this.disableLocation = res.data.confirmBaseInfo === 1 && res.data.location;
            } else {
              this.disableLocation = false;
            }
          });
        } else if (this.activeTab === "email") {
          getLocationInfoEmail({
            conferenceId: this.$route.params.conferenceId,
            email: this.form.account,
          }).then((res) => {
            if (res && res.data) {
              this.form.location = res.data.location;
              this.disableLocation = res.data.confirmBaseInfo === 1 && res.data.location;
            } else {
              this.disableLocation = false;
            }
          });
        }
      }
    },
    Submit() {
      console.log("submit");
      this.form.conferenceId = this.$route.params.conferenceId;
      if (this.type === "GT") {
        guestLogin(this.form).then((res) => {
          if (res && res.success) {
            this.$router.push({ path: "personal" });
          }
        });
      } else if (this.type === "MT") {
        mediaLogin(this.form).then((res) => {
          if (res && res.success) {
            this.$store.dispatch("user/getInfo").then(() => {
              if (this.status === "ENABLE") {
                this.$router.push({ path: "mediaSuccess" });
              } else {
                this.$router.push({ path: "mediaConfirm" });
              }
            });
          }
        });
      } else if (this.type === "WK") {
        workerLogin(this.form).then((res) => {
          if (res && res.success) {
            this.$store.dispatch("user/getInfo").then(() => {
              if (this.status === "ENABLE") {
                this.$router.push({ path: "mediaSuccess" });
              } else {
                this.$router.push({ path: "mediaConfirm" });
              }
            });
          }
        });
      } else if (this.type === "GZ") {
        guangzhouLogin(this.form).then((res) => {
          if (res && res.success) {
            this.$store.dispatch("user/getInfo").then(() => {
              if (this.status === "ENABLE") {
                this.$router.push({ path: "mediaSuccess" });
              } else {
                this.$router.push({ path: "mediaConfirm" });
              }
            });
          }
        });
      }
    },
    SubmitNoCapture() {
      this.form.conferenceId = this.$route.params.conferenceId;
      guestLoginNoCapture(this.form).then((res) => {
        if (res && res.success) {
          this.$router.push({ path: "personal" });
        }
      });
    },
    goRegister() {
      this.$store.dispatch("user/logout").then(() => {
        if (this.$route.params.type === "MT") {
          this.$router.push("media");
        } else if (this.$route.params.type === 'WK') {
          this.$router.push("staff");
        } else {
          this.$router.push("guangzhou")
        }
      });
    },
    checkTimeBetween(start, end) {
      if (!start || !end) {
        return false;
      }
      const now = new Date();
      const startDate = new Date(start.replace(/-/g, "/"));
      const endDate = new Date(end.replace(/-/g, "/"));
      if (now >= startDate && now <= endDate) {
        return true;
      }
      return false;
    },
    onConfirm(value, idx) {
      this.typeIdx = idx;
      this.showPicker = false;
      this.form.loginType = this.loginTypeDict[idx];
    },
    onConfirmLocation(value) {
      this.form.location = {
        广州本地: "广州本地",
        外地: "外地",
        Local: "广州本地",
        Guangzhou: "广州本地",
        "Other Place": "外地",
      }[value];
      this.showLocationPicker = false;
    },
    langChange(lang) {
      this.$changeLocale(lang);
      this.initLanguage();
    },
    sendCode() {
      if (this.form.loginType === "phone") {
        this.$refs.form.validate("account").then(() => {
          checkSmsExist({
            account: this.form.account,
            conferenceId: this.$route.params.conferenceId,
          }).then((res) => {
            if (res.success) {
              this.codeTime = this.codeInitTime;
              sendSmsCode({ account: this.form.account });
            }
          });
        });
      } else if (this.form.loginType === "email") {
        this.$refs.form.validate("account").then(() => {
          checkEmailExist({
            account: this.form.account,
            conferenceId: this.$route.params.conferenceId,
          }).then((res) => {
            if (res.success) {
              this.codeTime = this.codeInitTime;
              sendEmailCode({ account: this.form.account });
            }
          });
        });
      }
    },
    loginTypeChange() {
      this.form = Object.assign({}, tmpForm);
      this.form.loginType = this.activeTab;
      this.form.cToken = this.cToken;
      this.$nextTick(() => {
        this.$refs.form?.resetValidation();
        this.$refs.form1?.resetValidation();
      });
    },
    validateAccount(value, rule) {
      if (this.activeTab === "phone") {
        rule.message = this.$t3("手机号格式有误", "Error phone format");
        return /^1[3-9][0-9]{9}$/.test(value);
      } else {
        rule.message = this.$t3(
          "邮箱格式有误",
          "E-mail is not in the required format."
        );
        return /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/.test(value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.language {
  position: absolute;
  top: 20px;
  right: 22px;
  font-size: 12px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #fff;
  display: flex;

  .left,
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .left {
    margin-right: 4px;
  }
  .right {
    margin-left: 4px;
  }

  .border {
    font-size: 10px;
    color: rgba($color: #fff, $alpha: 0.5);
    font-weight: 400;
  }

  span.opacity3 {
    color: rgba($color: #fff, $alpha: 0.5);
  }
}

.pages .form-box .form-body .van-button.register-btn {
  margin-top: 15px;
  margin-bottom: 25px;
  background: transparent;
  border-radius: 23px;
  border: 1px solid #026de0;
  color: #026de0;
}

.forgot-password {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  font-weight: 400;
  color: #026de0;
  line-height: 17px;

  &.en {
    bottom: -52px;
  }

  span {
    position: relative;
    width: max-content;
    border-bottom: 1px solid #026de0;
    padding-bottom: 0.05rem;
    // &::after {
    //   position: absolute;
    //   bottom: -3px;
    //   left: 0;
    //   content: '';
    //   width: 100%;
    //   height: 1px;
    //   background: #fff;
    // }
  }
}
</style>
